import React from 'react';
import { Link } from 'react-router-dom';
import settings from '../../constants/settings';

const ServiceCard = ({ service }) => {
  // Function to handle order button click
  const handleOrderClick = (e) => {
    e.preventDefault();
    // Get the consultant number from settings and create the WhatsApp link
    const consultantNumber = settings.wa_consultant_link.replace('https://wa.me/', '');
    const message = `Saya tertarik dengan layanan: ${service.title}`;
    window.open(`https://wa.me/${consultantNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };
  
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow">
      <Link to={`/layanan/${service.id}`} className="block">
        <div className="aspect-[16/9] overflow-hidden bg-gray-100">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = '/images/services/placeholder.svg';
            }}
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="mb-2">
          <Link to={`/layanan/${service.id}`} className="block">
            <h3 className="text-lg font-semibold text-gray-900 line-clamp-2 hover:text-gold transition-colors">{service.title}</h3>
          </Link>
        </div>
        <p className="text-gray-600 mb-4 line-clamp-3">{service.description}</p>
        <div className="flex justify-between items-center">
          <span className="text-gold font-medium text-sm">{service.price}</span>
          <div>
            <button
              className="inline-flex items-center justify-center bg-gold hover:bg-dark-navy text-white font-medium rounded-md px-3 py-1.5 text-sm transition-colors"
              onClick={handleOrderClick}
            >
              Order
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;